import { cartCookieName } from '~/enums/cookieNameEnum'

export const setCustomerCart = async () => {
  // merge existing cart with customer cart
  const { setCart } = useCart()
  const { cartLoaded } = storeToRefs(useCartStore())
  const { $magento } = useNuxtApp()
  const cartCookie = useCookie(cartCookieName)
  const cartId = cartCookie.value
  const currentCartId = cartId?.indexOf('|') ? cartId.split('|').pop() : cartId

  // Load current cart
  const { data: cart, errors: cartErrors } = await $magento.customerCart()

  cartLoaded.value = true
  if (cartErrors?.length) {
    throw handleError(cartErrors, 'useCustomer', 'setCustomerCart')
  }
  const newCartId = cart?.customerCart?.id

  // Merge existing cart with customer cart (if needed)
  if (newCartId && currentCartId && currentCartId !== newCartId) {
    const { data: dataMergeCart, errors } = await $magento.mergeCarts({
      sourceCartId: currentCartId,
      destinationCartId: newCartId,
    })

    if (errors?.length) {
      throw handleError(errors, 'useCustomer', 'setCustomerCart')
    }

    setCart(dataMergeCart.mergeCarts)
    cartCookie.value = `${dataMergeCart.mergeCarts.total_quantity}|${dataMergeCart.mergeCarts.id}`
  } else {
    setCart(cart?.customerCart)
    cartCookie.value = `${cart?.customerCart?.total_quantity}|${cart?.customerCart?.id}`
  }
}
